import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconZoomInComponent } from "./med-icon-zoom-in.component";

@NgModule({
  declarations: [
    MedIconZoomInComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconZoomInComponent,
  ],
})
export class MedIconZoomInModule { }
